import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  diagnosticos: [],
  error: "", // for error message
  loading: false,
  errorMsg: false, // for error
  colorMsg: "",
  exito: false,
};

const diagnosticosSlice = createSlice({
  name: "diagnosticos",
  initialState,
  reducers: {
    apiError(state, action) {
      state.error = action.payload;
      state.loading = false;
      state.errorMsg = true;
      state.colorMsg = "danger";
    },

    diagnosticosSuccess(state, action) {
      console.log('🔍 diagnosticosSuccess - payload completo:', action.payload);
      console.log('📦 action.payload.data:', action.payload.data);
      console.log('📊 action.payload.data.data:', action.payload.data.data);
      
      // El backend devuelve [Array(14569), 14569] - necesitamos solo el primer elemento
      const diagnosticosData = action.payload.data.data;
      
      // Si es un array con 2 elementos donde el primero es un array, usar el primero
      if (Array.isArray(diagnosticosData) && diagnosticosData.length === 2 && Array.isArray(diagnosticosData[0])) {
        state.diagnosticos = diagnosticosData[0];
        console.log('⚠️ Backend devolvió [Array, count] - usando solo el Array');
      } else if (Array.isArray(diagnosticosData)) {
        // Si es un array normal, usarlo directamente
        state.diagnosticos = diagnosticosData;
      } else {
        // Fallback: array vacío
        state.diagnosticos = [];
        console.error('❌ Formato de datos inesperado:', diagnosticosData);
      }
      
      state.loading = false;
      state.errorMsg = true;
      state.colorMsg = "success";
      state.error = action.payload.data.message;
      state.exito = true;
      
      console.log('✅ state.diagnosticos asignado (total):', state.diagnosticos?.length || 0, 'diagnósticos');
    },

    reset_diagnostico_flag(state) {
      state.success = false;
      state.error = "";
      state.loading = false;
      state.errorMsg = false;
      state.colorMsg = "";
    },
  },
});

export const {
  apiError,
  diagnosticosSuccess,
  reset_diagnostico_flag,
} = diagnosticosSlice.actions;

export default diagnosticosSlice.reducer;
